import {TableSchemaService} from '@services/Table';
import {setItems, setMenuLoading} from './menuSlice';
import {
    MenuItem,
    ServerMenu,
    ServerMenuCode,
    ServerMenuTab,
    ServerMenuTabType,
} from '../../types/common';
import {ModuleMenu} from 'constants/menu';
import {createAsyncThunk} from '@reduxjs/toolkit';

const service = TableSchemaService.getInstance();

export const getMenuItems = createAsyncThunk(
    'menu/getMenuItems',
    async (module: ModuleMenu, {dispatch}) => {
        try {
            dispatch(setMenuLoading(true));
            const menu = await service.getMenu(module);

            const menuItems = mapServerMenuToMenuItems(menu);

            dispatch(setItems(menuItems));
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setMenuLoading(false));
        }
    },
);

export const mapServerMenuToMenuItems = (items: ServerMenu[]): MenuItem[] => {
    return items.map((item) => ({
        key: '',
        label: item.title,
        isGroup: false,
        isFiles: false,
        isCalendar: false,
        type: ServerMenuTabType.MENU,
        pathCode: item.code || '',
        children: item.tabs ? mapServerMenuTabsToMenuItems(item.tabs) : [],
        menuTypeCode: item.code,
    }));
};
export const mapServerMenuTabsToMenuItems = (
    items: ServerMenuTab[],
    serverMenuCode?: ServerMenuCode,
): MenuItem[] => {
    return items.map((item) => ({
        key: getMenuItemKey(item),
        label: item.title,
        isGroup: item.type === ServerMenuTabType.Group,
        isFiles: item.type === ServerMenuTabType.Files,
        isCalendar:
            item.type === ServerMenuTabType.CalendarOperations ||
            item.type === ServerMenuTabType.MudFactCalendar,
        type: item.type,
        pathCode: item.pathCode,
        findAllUrl: (item.findAllUrl || '').replace('/api', ''),
        children: item.tabs ? mapServerMenuTabsToMenuItems(item.tabs) : [],
        menuTypeCode: serverMenuCode,
    }));
};

export const getMenuItemKey = (item: ServerMenuTab): string | string[] => {
    if (item.type === ServerMenuTabType.Nested && item.tabs) {
        return item.tabs.flatMap((item) => getMenuItemKey(item));
    }
    return item.pathCode;
};
